/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentFolder =
    (typeof DocumentFolder)[keyof typeof DocumentFolder];

export const DocumentFolder = {
    Other: 0,
    HealthSafetyAndCompliance: 1,
    ConstructionAndDevelopment: 2,
    BuildingOperationsAndFacilities: 3,
    Drawings: 4,
    EnvironmentalAndSite: 5,
    PropertyAndLegal: 6,
    FinanceAndInsurance: 7,
} as const;
